import { useEffect, useReducer, useRef } from "react";
import type { DeviceType } from "@intelligems/ig-types/schemas/analytics/base";
import { styled, SxProps } from "@mui/material/styles";

import { ScaledIFrame } from "./ScaledIFrame";
import { ReverseProxyController } from "@src/components/ReverseProxy/ReverseProxyController";

export interface ReverseProxyProps {
  src?: string;
  id?: string;
  renderAs?: DeviceType;
  sx?: SxProps;
}

export const ReverseProxy = ({
  src,
  id,
  renderAs,
  sx,
  controller,
}: ReverseProxyProps & { controller: ReverseProxyController<any> }) => {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    controller.init({ ref: iframeRef, forceUpdate });
    return () => controller.destroy();
  }, []);

  const onLoad = () => controller.onLoad();
  const onError = () => controller.onError();

  if (renderAs) {
    return (
      <ScaledIFrame
        id={id}
        ref={iframeRef}
        device={renderAs}
        src={src}
        sx={sx}
        onLoad={onLoad}
        onError={onError}
      />
    );
  } else {
    return (
      <IFrame
        id={id}
        ref={iframeRef}
        src={src}
        sx={sx}
        onLoad={onLoad}
        onError={onError}
      />
    );
  }
};

const IFrame = styled("iframe")(() => ({}));
